"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Tooltip = _interopRequireDefault(require("../../Tooltip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Star = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(Star, _React$Component);

  var _super = _createSuper(Star);

  function Star() {
    (0, _classCallCheck2.default)(this, Star);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Star, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          changeRating = _this$props.changeRating,
          hoverOverStar = _this$props.hoverOverStar,
          unHoverOverStar = _this$props.unHoverOverStar,
          svgIconViewBox = _this$props.svgIconViewBox,
          svgIconPath = _this$props.svgIconPath,
          isSelected = _this$props.isSelected,
          isPartiallyFullStar = _this$props.isPartiallyFullStar,
          isHovered = _this$props.isHovered,
          isCurrentHoveredStar = _this$props.isCurrentHoveredStar,
          ignoreInlineStyles = _this$props.ignoreInlineStyles,
          starDimension = _this$props.starDimension,
          isStarred = _this$props.isStarred,
          hoverMode = _this$props.hoverMode,
          starEmptyColor = _this$props.starEmptyColor,
          starRatedColor = _this$props.starRatedColor,
          starHoverColor = _this$props.starHoverColor,
          gradientPathName = _this$props.gradientPathName,
          fillId = _this$props.fillId,
          starSpacing = _this$props.starSpacing,
          isFirstStar = _this$props.isFirstStar,
          isLastStar = _this$props.isLastStar,
          starNumber = _this$props.starNumber,
          numberOfStars = _this$props.numberOfStars,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["className", "changeRating", "hoverOverStar", "unHoverOverStar", "svgIconViewBox", "svgIconPath", "isSelected", "isPartiallyFullStar", "isHovered", "isCurrentHoveredStar", "ignoreInlineStyles", "starDimension", "isStarred", "hoverMode", "starEmptyColor", "starRatedColor", "starHoverColor", "gradientPathName", "fillId", "starSpacing", "isFirstStar", "isLastStar", "starNumber", "numberOfStars"]);
      return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        delay: "instant",
        title: "".concat(this.props.starNumber, " out of ").concat(this.props.numberOfStars, " stars"),
        placement: "bottom"
      }, /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
        className: (0, _classnames.default)("star-container ", className),
        type: "button",
        style: this.starContainerStyle,
        onMouseEnter: hoverOverStar,
        onMouseLeave: unHoverOverStar,
        onClick: changeRating,
        disabled: this.props.disabled
      }, otherProps), /*#__PURE__*/_react.default.createElement("svg", {
        viewBox: svgIconViewBox,
        className: this.starClasses,
        style: this.starSvgStyle
      }, /*#__PURE__*/_react.default.createElement("path", {
        className: "star",
        style: this.pathStyle,
        d: svgIconPath
      }))));
    }
  }, {
    key: "starContainerStyle",
    get: function get() {
      var _this$props2 = this.props,
          changeRating = _this$props2.changeRating,
          starSpacing = _this$props2.starSpacing,
          isFirstStar = _this$props2.isFirstStar,
          isLastStar = _this$props2.isLastStar,
          ignoreInlineStyles = _this$props2.ignoreInlineStyles;
      var starContainerStyle = {
        position: "relative",
        display: "inline-block",
        verticalAlign: "middle",
        paddingLeft: isFirstStar ? undefined : starSpacing,
        paddingRight: isLastStar ? undefined : starSpacing,
        cursor: changeRating ? "pointer" : undefined
      };
      return ignoreInlineStyles ? {} : starContainerStyle;
    }
  }, {
    key: "starSvgStyle",
    get: function get() {
      var _this$props3 = this.props,
          ignoreInlineStyles = _this$props3.ignoreInlineStyles,
          isCurrentHoveredStar = _this$props3.isCurrentHoveredStar,
          starDimension = _this$props3.starDimension;
      var starSvgStyle = {
        width: starDimension,
        height: starDimension,
        transition: "transform .2s ease-in-out",
        transform: isCurrentHoveredStar ? "scale(1.1)" : undefined
      };
      return ignoreInlineStyles ? {} : starSvgStyle;
    }
  }, {
    key: "pathStyle",
    get: function get() {
      var _this$props4 = this.props,
          isStarred = _this$props4.isStarred,
          isPartiallyFullStar = _this$props4.isPartiallyFullStar,
          isHovered = _this$props4.isHovered,
          hoverMode = _this$props4.hoverMode,
          starEmptyColor = _this$props4.starEmptyColor,
          starRatedColor = _this$props4.starRatedColor,
          starHoverColor = _this$props4.starHoverColor,
          gradientPathName = _this$props4.gradientPathName,
          fillId = _this$props4.fillId,
          ignoreInlineStyles = _this$props4.ignoreInlineStyles;
      var fill;

      if (hoverMode) {
        if (isHovered) fill = starHoverColor;else fill = starEmptyColor;
      } else {
        if (isPartiallyFullStar) fill = "url('".concat(gradientPathName, "#").concat(fillId, "')");else if (isStarred) fill = starRatedColor;else fill = starEmptyColor;
      }

      var pathStyle = {
        fill: fill,
        transition: "fill .2s ease-in-out"
      };
      return ignoreInlineStyles ? {} : pathStyle;
    }
  }, {
    key: "starClasses",
    get: function get() {
      var _this$props5 = this.props,
          isSelected = _this$props5.isSelected,
          isPartiallyFullStar = _this$props5.isPartiallyFullStar,
          isHovered = _this$props5.isHovered,
          isCurrentHoveredStar = _this$props5.isCurrentHoveredStar,
          ignoreInlineStyles = _this$props5.ignoreInlineStyles;
      var starClasses = (0, _classnames.default)({
        "widget-svg": true,
        "widget-selected": isSelected,
        "multi-widget-selected": isPartiallyFullStar,
        hovered: isHovered,
        "current-hovered": isCurrentHoveredStar
      });
      return ignoreInlineStyles ? {} : starClasses;
    }
  }]);
  return Star;
}(_react.default.Component);

Star.propTypes = {
  fillId: _propTypes.default.string.isRequired,
  changeRating: _propTypes.default.func,
  hoverOverStar: _propTypes.default.func,
  unHoverOverStar: _propTypes.default.func,
  isStarred: _propTypes.default.bool.isRequired,
  isPartiallyFullStar: _propTypes.default.bool.isRequired,
  isHovered: _propTypes.default.bool.isRequired,
  hoverMode: _propTypes.default.bool.isRequired,
  isCurrentHoveredStar: _propTypes.default.bool.isRequired,
  isFirstStar: _propTypes.default.bool.isRequired,
  isLastStar: _propTypes.default.bool.isRequired,
  starDimension: _propTypes.default.string.isRequired,
  starSpacing: _propTypes.default.string.isRequired,
  starHoverColor: _propTypes.default.string.isRequired,
  starRatedColor: _propTypes.default.string.isRequired,
  starEmptyColor: _propTypes.default.string.isRequired,
  gradientPathName: _propTypes.default.string.isRequired,
  ignoreInlineStyles: _propTypes.default.bool.isRequired,
  svgIconPath: _propTypes.default.string.isRequired,
  svgIconViewBox: _propTypes.default.string.isRequired,
  isSelected: _propTypes.default.bool,
  starNumber: _propTypes.default.number,
  numberOfStars: _propTypes.default.number,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
var _default = Star;
exports.default = _default;